'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $("[data-delivery-note-export-save]", this).each(function () {
        $(this).on("click", function () {
            var json = $($(this).attr("data-result-input-selector")).val();
            var exportFormat = $($(this).attr("data-export-format-selector")).val();
            // console.log(json);
            // console.log(exportFormat);
            deliverynoteexportService.saveSettings({ UsedColumnsNestableResult: json, ExportFormat: exportFormat }).done(function (result) {
                abp.notify.success(Resx.Common.SettingsSaved);
            }).fail(function (result) {
                abp.notify.error(Resx.Common.AjaxError);
            });
        });
    });

    $("[data-nestable]", this).each(function () {
        $(this).nestable({ group: 1, maxDepth: 1 });
        if ($(this).attr("data-result-input-selector")) {
            var input = $($(this).attr("data-result-input-selector"));
            $(this).on('change', updateOutput);
            updateOutput($(this).data('output', input));
        }
    });
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
var deliverynoteexportService = abp.services.api.deliverynoteexport;

var Resx = (0, _localize2.default)('Common');

function updateOutput(e) {
    var list = e.length ? e : $(e.target),
        output = list.data('output');
    if (window.JSON) {
        output.val(window.JSON.stringify(list.nestable('serialize')));
    }
}

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/nestable.js
// module id = 1074
// module chunks = 1